import api from "Core/api";
import { cookie } from "Core/utils";

const logout = async () => {
  cookie.deleteToken();
  delete api.defaults.headers.common["Authorization"];
};

export default logout;
